import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp } from '../lib/whatsapp';

const { FiArrowUpRight } = FiIcons;

const posts = [
  {
    tag: 'Materials',
    title: 'Why we love limewashed walls',
    excerpt: 'Texture, depth, and a finish that only gets better with age.',
    image: 'https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=1000&q=80'
  },
  {
    tag: 'Process',
    title: 'Designing for slow mornings',
    excerpt: 'How the right layout can change the way a day begins.',
    image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1000&q=80'
  },
  {
    tag: 'Sourcing',
    title: 'The vintage pieces we always hunt for',
    excerpt: 'A short list of the objects that make a room feel lived-in.',
    image: 'https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&w=1000&q=80'
  }
];

function JournalSection() {
  return (
    <section className="journal-section section-wrap" id="journal">
      <div className="section-heading">
        <div>
          <p className="eyebrow">From the journal</p>
          <h2>
            Notes on
            <br />
            <em>making a home.</em>
          </h2>
        </div>
      </div>
      <div className="journal-grid">
        {posts.map((post, i) => (
          <motion.button
            type="button"
            key={i}
            className="journal-card"
            onClick={() => openWhatsApp(`Hello Forma Interiors, I'd like to read more about "${post.title}".`)}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <div className="journal-image">
              <img src={post.image} alt={post.title} loading="lazy" />
              <span className="journal-tag">{post.tag}</span>
            </div>
            <div className="journal-copy">
              <h3>{post.title}</h3>
              <p>{post.excerpt}</p>
              <span className="journal-link">
                Read more <SafeIcon icon={FiArrowUpRight} />
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </section>
  );
}

export default JournalSection;
